import { AbstractEntity } from "../AbstractEntity";
export var ViewTypes;
(function (ViewTypes) {
    ViewTypes["Partner"] = "partner";
    ViewTypes["EquipmentHistory"] = "equipment history";
})(ViewTypes || (ViewTypes = {}));
export class View extends AbstractEntity {
    name;
    icon;
    config = {};
    book;
    constructor(view = {}) {
        super();
        Object.assign(this, view);
    }
}
//# sourceMappingURL=View.js.map